import React from 'react';
import styled from 'styled-components';

const StyledSpinner = styled.div` 
	position: ${props => props.display === "inline" ? 'relative' : 'absolute'};
	top: ${props => props.top ? props.top :  '50%' }; left: ${props => props.left ? props.left :  '50%' };
	transform: translate(-50%);

	display: block;
	color: ${props => props.color ? props.color : "#f5f5f5"};

	font-size: 12px; font-size: var(--font-2);
	
	@keyframes spinner {
		to {transform: rotate(360deg);}
	}
	
	&::before {
		content: '';

		position: relative;
		left: 25%;

		display: block;

		box-sizing: border-box;
		width: 20px; width: 1.2vmax;
		height: 20px; height: 1.2vmax;
		border-radius: 50%;
		border: 2px solid #888;
		border-top-color: #fff;

		animation: spinner .6s linear infinite;
	}	
`

const StyledSpinnerButton = styled.div`
	width: 100%;
	height: 25%;
	margin-top: 1vh;
	display: flex;
	justify-content: center;
	border: 2px solid;
	background: white;
	border-radius: 3px;

	&::before {
		content: '';

		position: relative;
		/* left: 25%; */

		display: block;

		box-sizing: border-box;
		width: 20px; width: 1vmax;
		height: 20px; height: 1vmax;
		border-radius: 50%;
		border: 2px solid #292626;
		border-top-color: #fff;

		animation: spinner .6s linear infinite;
	}
`

export const Spinner = (props) => (
	<StyledSpinner {...props} className="spinner">
		{props.message ? props.message : 'Loading...'}
	</StyledSpinner>
)

export const SpinnerButton = () => (
	<StyledSpinnerButton></StyledSpinnerButton>
)